<script>
import { ModuleManager } from "@module-system";
import VideoCallButton from "@/components/Common/VideoCallButton.vue";
import { EventManager } from "@events";

export default {
  name: "ListConatiner",
  components: {
    VideoCallButton,
  },
  props: {
    sectionType: {
      type: String,
      required: true,
    },
    rtcId: {
      type: String,
      required: false,
    },
    maxStackableBtns: {
      type: Number,
      required: false,
      default: 8,
    },

    // Adding this will prevent a vue.js warning
    modelValue: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      numOfAllButtons: ModuleManager.getViewModules(this.sectionType, this.rtcId)?.value?.length ?? 0,
      isSecondListShown: false,
    };
  },
  computed: {
    modules() {
      let modules = ModuleManager.getViewModules(this.sectionType, this.rtcId)?.value;

      if (modules.length > this.maxStackableBtns) {
        let { firstList } = this.separateStackableModules(modules);
        return firstList;
      }

      return modules;
    },
    modules2() {
      let modules = ModuleManager.getViewModules(this.sectionType, this.rtcId)?.value;

      if (modules.length > this.maxStackableBtns) {
        let { secondList } = this.separateStackableModules(modules);
        return secondList;
      }

      return [];
    },
  },
  methods: {
    allProps(module) {
      let allProps = { ...this.$props };
      // filter out modelValue from props if it is not defined
      if (!allProps.modelValue) {
        delete allProps.modelValue;
      }

      if (allProps.sectionType) {
        delete allProps.sectionType;
      }

      return { ...allProps, ...module.props, ...this.$attrs, ...module.attrs, ...module.listeners, ...module.slots };
    },
    separateStackableModules(modules) {
      let firstList = [];
      let secondList = [];

      if (modules.length > this.maxStackableBtns) {
        for (let i = modules.length - 1; i >= 0; i--) {
          if (modules[i].stackable === false) {
            firstList.unshift(modules.splice(i, 1)[0]);
          }
        }

        if (firstList.length < this.maxStackableBtns - 1) {
          for (let i = modules.length - 1; i >= 0; i--) {
            if (firstList.length < this.maxStackableBtns - 1) {
              firstList.unshift(modules.splice(i, 1)[0]);
            } else {
              break;
            }
          }
        }

        secondList = modules;
      } else {
        firstList = modules;
      }

      return { firstList, secondList };
    },
  },
  created() {
    if (this.modules.length == 0) {
      console.info(`ListContainer: ${this.sectionType} => no modules found`);
    } else {
      const names = this.modules.map((m) => m.key).join(", ");
      console.log(`ListContainer:  ${this.sectionType} => loaded ${this.modules.length} modules (${names})`);
    }
    EventManager.getActionEmitter(this.$props.rtcId).on("hide-stackable-buttons", () => {
      this.isSecondListShown = false;
    });
  },
};
</script>

<template>
  <div id="parent-container">
    <div>
      <VideoCallButton
        v-if="numOfAllButtons > this.maxStackableBtns"
        icon="mdi-dots-vertical"
        @click="isSecondListShown = !isSecondListShown" />
      <component v-for="m of modules" :is="m.ViewComponent" :key="m.key" v-bind="allProps(m)" />
    </div>

    <div v-if="isSecondListShown" id="list-container2">
      <component v-for="m of modules2" :is="m.ViewComponent" :key="m.key" v-bind="allProps(m)" />
    </div>
  </div>
</template>

<style scoped>
#parent-container {
  display: flex;
}

#list-container2 {
  margin-left: 15px;
  margin-top: 32px;
  height: 75%;
}
</style>
